var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForMoreDetailsBottomLineMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 2,
    viewBox: "0 0 309 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.163024 0.857422L1 1.6944L1.83698 0.857422L1 0.0204455L0.163024 0.857422ZM308.837 0.857422L308 0.0204455L307.163 0.857422L308 1.6944L308.837 0.857422ZM1 1.00239H308V0.712453H1V1.00239Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForMoreDetailsBottomLineMob);
export default __webpack_public_path__ + "static/media/for-more-details-Bottom-line-mob.3e41c27b044849fcb40207cb5541c62c.svg";
export { ForwardRef as ReactComponent };